import React from 'react';
import { Shield, Eye, Lock, FileText, MapPin } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const Privacy = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative h-[400px] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1635367216109-aa3353c0c22e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHw0fHxoZWFsdGglMjB3ZWxsbmVzc3xlbnwwfHx8fDE3NzA3NjE1NjZ8MA&ixlib=rb-4.1.0&q=85)',
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-teal-900/80 to-cyan-700/80" />
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center text-white">
          <Shield className="h-16 w-16 mx-auto mb-4" />
          <h1 className="text-5xl md:text-6xl font-bold mb-4">Privacy Policy</h1>
          <p className="text-xl">Your privacy and data protection</p>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-6 py-16">
        {/* Introduction */}
        <Card className="mb-12 bg-gradient-to-br from-teal-50 to-cyan-50">
          <CardContent className="p-8">
            <p className="text-lg text-gray-700 leading-relaxed">
              This privacy notice applies to personal information that we collect through this website: <strong>www.cheers.org.nz</strong>
            </p>
          </CardContent>
        </Card>

        {/* Personal Information */}
        <Card className="mb-12">
          <CardHeader>
            <CardTitle className="flex items-center text-2xl">
              <Eye className="mr-3 h-8 w-8 text-teal-600" />
              Personal Information
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-gray-700 leading-relaxed">
              We do not collect personal information on this site unless you choose to give it to us.
            </p>
            <p className="text-gray-700 leading-relaxed">
              The only time we will ask you for personal information is when you send us an enquiry or feedback.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Everyone involved with The Tomorrow Project may see the information you provide.
            </p>
            <p className="text-gray-700 leading-relaxed">
              We do not collect identifiable information about you if you only browse our website.
            </p>
          </CardContent>
        </Card>

        {/* Use and Disclosure */}
        <Card className="mb-12">
          <CardHeader>
            <CardTitle className="flex items-center text-2xl">
              <Lock className="mr-3 h-8 w-8 text-cyan-600" />
              Use and Disclosure
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-gray-700 leading-relaxed">
              We will only use personal information that you provide to us through this site for the purposes for which you supplied it or, in exceptional situations, for other reasons permitted under the Privacy Act 1993.
            </p>
            <p className="text-gray-700 leading-relaxed">
              We generally do not share your personal information with others unless this is necessary for the purpose for which you gave us the information. Occasionally the law may require us to disclose it (for instance to investigate a criminal offence), or there may be safety reasons for disclosing it.
            </p>
            <p className="text-gray-700 leading-relaxed">
              We analyse non-identifiable web traffic data to improve our services.
            </p>
          </CardContent>
        </Card>

        {/* Your Rights and Choices */}
        <Card className="mb-12">
          <CardHeader>
            <CardTitle className="flex items-center text-2xl">
              <FileText className="mr-3 h-8 w-8 text-blue-600" />
              Your Rights and Choices
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-gray-700 leading-relaxed">
              We are happy to provide you with access to any personal information that we hold about you. If it is wrong, please ask us to correct it. To ask for access and correction, see our contact details.
            </p>
          </CardContent>
        </Card>

        {/* Contact Information */}
        <Card className="bg-gradient-to-br from-teal-600 to-cyan-700 text-white">
          <CardHeader>
            <CardTitle className="flex items-center text-2xl">
              <MapPin className="mr-3 h-8 w-8" />
              Information Held By
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="bg-white/20 backdrop-blur-sm p-6 rounded-lg">
              <p className="text-lg mb-2"><strong>The Tomorrow Project</strong></p>
              <p className="text-lg">C/- Level 5, 56 Victoria Street</p>
              <p className="text-lg">Wellington, New Zealand</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Privacy;